export default __webpack_public_path__ + "static/media/light_mode_edit_icon.d68a0e81.svg";